<template>
    <v-row>
        <v-col cols="6" sm="">
            <v-btn v-bind="{ loading }" block class="border" @click="toggleAudio">
                <template v-if="enabled_audio">
                    <v-icon class="mr-8"> mdi-microphone-off </v-icon>
                    <span> 마이크 끄기 </span>
                </template>
                <template v-else>
                    <v-icon class="mr-8"> mdi-microphone </v-icon>
                    <span> 마이크 켜기 </span>
                </template>
            </v-btn>
        </v-col>
        <v-col cols="6" sm="">
            <v-btn v-bind="{ loading }" block class="border" @click="toggleMuted">
                <template v-if="enabled_muted">
                    <v-icon class="mr-8"> mdi-volume-high </v-icon>
                    <span> 음소거 끄기 </span>
                </template>
                <template v-else>
                    <v-icon class="mr-8"> mdi-volume-off </v-icon>
                    <span> 음소거 켜기 </span>
                </template>
            </v-btn>
        </v-col>
        <v-col cols="6" sm="">
            <v-btn v-bind="{ loading }" block class="border" @click="toggleVideo">
                <template v-if="enabled_video">
                    <v-icon class="mr-8"> mdi-camera-off </v-icon>
                    <span> 화면 끄기 </span>
                </template>
                <template v-else>
                    <v-icon class="mr-8"> mdi-camera </v-icon>
                    <span> 화면 켜기 </span>
                </template>
            </v-btn>
        </v-col>
        <v-col cols="6" sm="">
            <v-btn v-bind="{ loading }" block color="red" dark @click="exit">
                <v-icon class="mr-8"> mdi-logout-variant </v-icon>
                <span> 나가기 </span>
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
export default {
    computed: {
        ...mapState("interview", ["loading"]),
        ...mapState("interview/client", ["enabled_audio", "enabled_video", "enabled_muted"]),
    },
    methods: {
        ...mapActions("interview/client", ["init"]),
        ...mapActions("interview/server", ["exit", "send"]),
        ...mapMutations("interview/client", ["toggleAudio", "toggleVideo", "toggleMuted"]),
    },
    watch: {
        enabled_audio() {
            this.send();
        },
        enabled_video() {
            this.send();
        },
    },
};
</script>

<style>
</style>